<template>
  <div class="wrapper">
    <div class="reset-card">
      <div class="reset-card-header">
        <img :src="require(`@/assets/logos/usecargoazul.png`)" alt="pickndrive" style="width: 120px; margin: 20%">
      </div>
      <form @submit.prevent="changePassword">
        <div class="form-group text-center">
          <label for="password-input">Nova senha</label>
          <input type="password" class="form-control" v-model="password" id="password-input" aria-describedby="emailHelp" placeholder="Nova senha">
        </div>
        <div class="form-group text-center">
          <label for="confirm-password-input">Confirmar nova senha</label>
          <input type="password" class="form-control" v-model="confirmPassword" id="confirm-password-input" aria-describedby="emailHelp" placeholder="Confirme sua nova senha">
          <small class="form-text text-muted">Se necessário anote sua senha para realizar o login mais tarde</small>
        </div>
        <button type="submit" class="btn btn-block white--text">REDEFINIR SENHA</button>
      </form>
    </div>
  </div>
</template>

<script>
import AuthController from "../../controllers/AuthController.js";
import theming from '../../mixins/theming'
export default {
  mixins: [theming],
  data() {
    return {
      email: null,
      password: null,
      confirmPassword: null
    };
  },

  created() {
    this.authController = new AuthController(
      this.$resource,
      this.$router,
      this.$message
    );
    const email = this.$route.params.email;
  },

  methods: {
    changePassword() {
      if (this.password === this.confirmPassword) {
        this.authController.changePassword(this.password).then(() => {
          this.$router.push({ name: "login" });
        });
      } else {
        this.$message({
          message: "As senhas informadas não são iguais!",
          type: "error"
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.wrapper {
  position: fixed;
  width: 100vw;
  height: 100%;
  //background: url('../../assets/background-desktop.png');
  background-color: white;
  background-size: cover;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  // justify-content: center;
  align-items: center;
  @media(max-width: 560px) {
    overflow: scroll;
    padding-bottom: 150px;
  }
}

.wrapper .reset-card {
  border-radius: 3px;
  padding: 15px 25px;
  width: 400px;
  @media (max-width: 600px) {
    width: 80%;
  }
}

.reset-card label {
  color: #222
}

.reset-card .change-visibility-span:hover {
  cursor: pointer;
}

.reset-card .reset-card-header {
  display: flex;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
  }
}

.forgot-password {
  display: flex;
  justify-content: flex-end;
  margin: 20px 0px;
}

.btn {
  background: var(--secondary-color) !important;
  font-weight: bold;
}

input {
  background: white;
  border: 1px solid #016ea7;
  color: #016ea7;
}

.form-control{
  border: 1px solid #016ea7;
}


</style>
